import './CommunityPopup.scss';
import CommunityPopupProps from './CommunityPopupProps';
import community_icon from '../../../../assets/images/community-icon.svg';
import { IoMdClose as CloseIcon } from "react-icons/io";
import SearchBox from '../../../core/SearchBox/SearchBox';
import CommunityMember from '../CommunityMember/CommunityMember';
import { useDispatch } from 'react-redux';
import { toggleCommunityPopup } from '../../../../store/actions/mainActions';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const CommunityPopup = (props: CommunityPopupProps) => {

    const dispatch = useDispatch();
    const { me } = useSelector((state: any) => state.auth)
    const [connections, setConnections] = useState([])
    const [searchInut, setSearchInput] = useState("")

    useEffect(() => {
        if (me?.connections && Array.isArray(me.connections)) {
            setConnections(me.connections)
        }
    }, [me?.connections])


    const handleSearch = (e: any) => {
        setSearchInput(e.target.value)
        if (e.target.value) {
            const _filtered = connections.filter((u: any) => {
                
                return u.fullName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
            });
            setConnections(_filtered)
        } else {
            if (me?.connections && Array.isArray(me.connections)) {
                setConnections(me.connections)
            }
        }
    }

    const handleClose = () => {
        dispatch(toggleCommunityPopup(false))
    }

    return (
        <div className="community-popup">
            <div className="popup-header">
                <div className="header-row">
                    <img src={community_icon} alt="community-icon" />
                    <div className="popup-title">My Hartman <span className="highlight">Community</span></div>
                    <CloseIcon className="close-icon" onClick={handleClose} />
                </div>
                <div className="mt-3">
                    <SearchBox
                        changeHandler={handleSearch}
                        placeholder={'Find friends from your community'}
                        classes="popup-input"
                        value={searchInut}
                    />
                </div>
            </div>
            <div className="popup-body">
                {connections?.map((member: any, index: number) => (
                    <div key={index}>
                        <CommunityMember member={member} onPopup={true} />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CommunityPopup;